module.exports = __webpack_public_path__ + "img/safe.016a2acf.png";